import React, { useState, useEffect, useCallback } from "react";

import { useHistory, useLocation, useParams } from "react-router-dom";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import {
  parse,
  isValid,
  intervalToDuration,
  format,
  isAfter,
  isBefore,
} from "date-fns";

import { Box, Flex } from "@chakra-ui/react";

import { CustomButton } from "../../../../components/CustomButton";
import { CriancaRegistrada } from "./CriancaRegistrada";
import { PossuiCartao } from "./PossuiCartao";
import { PossuiIdentidade } from "./PossuiIdentidade";
import { PossuiCPF } from "./PossuiCPF";
import { PossuiCTPS } from "./PossuiCTPS";
import { PossuiNumero } from "./PossuiNumero";

import DocumentacaoService from "../../../../../main/services/DocumentacaoService";
import CriancaService from "../../../../../main/services/CriancaService";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import SemRegistros from "../../../../components/SemRegistros";
import {
  criancaFunc,
  vrCriancaFunc,
} from "../../../../../helpers/Funcionalidades";
import { isValidCPF } from "../../../../utils/isValidCPF";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { scrollToFieldAnexo } from "../../../../utils/scrollToFIeldAnexo";

export const EditarDocumentacao = ({ dataNascimento }) => {
  const history = useHistory();
  const { id } = useParams();
  const [dataFutura, setDataFutura] = useState(false);
  const [dataMenor, setDataMenor] = useState(false);
  const [acolhedorValid, setAcolhedorValid] = useState(false);
  const [message, setMessage] = useState(false);
  const { setAtualizarDocumentacao, idPJ } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const isNascidoAposMar2011 =
    dataNascimento >= new Date("2011-03-01").getTime();
  const [invalidCPF, setInvalidCPF] = useState(false);
  const suportedFormats = [
    ".png",
    ".bmp",
    ".tiff",
    ".jpg",
    ".jpeg",
    ".doc",
    ".docx",
    ".txt",
    ".dot",
    ".pdf",
    ".xml",
    ".xls",
    ".xlam",
    ".ods",
  ];

  const [dataCrianca, setDataCrianca] = useState();
  const [certidaoEditada, setCertidaoEditada] = useState();
  const [identidadeEditada, setIdentidadeEditada] = useState();
  const [anexoCpfEditado, setAnexoCpfEditado] = useState();
  const [ctpsEditada, setCtpsEditada] = useState();
  const { setEditarDocCrianca } = useAppContext();
  const [initialValues, setInitialValues] = useState({
    registrada: "",
    matricula: "",
    livro: "",
    folha: "",
    termo: "",
    certidao: null,
    possuiIdentidade: "",
    numeroIdentidade: "",
    orgaoExpedidor: "",
    dataExpedicaoIdentidade: "",
    identidade: null,
    possuiCpf: "",
    cpf: "",
    anexoCpf: null,
    possuiCtps: "",
    numeroCtps: "",
    serieCtps: "",
    dataExpedicaoCtps: "",
    ctps: null,
    possuiCartaoSus: "",
    numeroCartaoSus: "",
    possuiNumeroIdentidadeSocial: "",
    numeroIdentidadeSocial: "",
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexo = searchParams.get("idAnexo");

  const scrollToField = useCallback(
    (ref) => {
      scrollToFieldAnexo(idAnexo, ref);
    },
    [idAnexo]
  );

  useEffect(() => {
    CriancaService.getCrianca(id)
      .then((res) => {
        setDataCrianca(res.data);
      })
      .catch((err) => console.log("Erro no get de crianca"));
    DocumentacaoService.getDocumentacao(id)
      .then((res) => {
        const {
          registrada,
          matricula,
          livro,
          folha,
          termo,
          certidao,
          possuiIdentidade,
          numeroIdentidade,
          orgaoExpedidor,
          dataExpedicaoIdentidade,
          identidade,
          possuiCpf,
          cpf,
          anexoCpf,
          dataExpedicaoCtps,
          possuiCtps,
          numeroCtps,
          serieCtps,
          ctps,
          possuiCartaoSus,
          numeroCartaoSus,
          possuiNumeroIdentidadeSocial,
          numeroIdentidadeSocial,
          ...resto
        } = res.data;

        function cpfValue(value) {
          let temp = value;
          temp = temp.replace(/\D/g, "");
          temp = temp.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
          return temp;
        }

        setInitialValues({
          registrada: registrada ? registrada.trim() : "",
          matricula: matricula ? matricula : "",
          livro: livro && !isNascidoAposMar2011 ? livro : "",
          folha: folha && !isNascidoAposMar2011 ? folha : "",
          termo: termo && !isNascidoAposMar2011 ? termo : "",
          numeroSolicitacaoCertNascimento: "",
          originalCertidao: certidao,
          certidao: null,
          possuiIdentidade: possuiIdentidade ? possuiIdentidade.trim() : "",
          numeroIdentidade: numeroIdentidade ? numeroIdentidade : "",
          orgaoExpedidor: orgaoExpedidor ? orgaoExpedidor : "",
          dataExpedicaoIdentidade: dataExpedicaoIdentidade
            ? format(new Date(dataExpedicaoIdentidade), "dd/MM/yyyy")
            : "",
          numeroSolicitacaoIdentidade: "",
          originalIdentidade: identidade,
          identidade: null,
          possuiCpf: possuiCpf ? possuiCpf.trim() : "",
          cpf: cpf ? cpfValue(cpf) : "",
          numeroSolicitacaoCPF: "",
          originalAnexoCpf: anexoCpf,
          anexoCpf: null,
          dataExpedicaoCtps: dataExpedicaoCtps
            ? format(new Date(dataExpedicaoCtps), "dd/MM/yyyy")
            : "",
          possuiCtps: possuiCtps ? possuiCtps.trim() : "",
          numeroCtps: numeroCtps ? numeroCtps : "",
          serieCtps: serieCtps ? serieCtps : "",
          originalCtps: ctps,
          ctps: null,
          possuiCartaoSus: possuiCartaoSus ? possuiCartaoSus.trim() : "",
          numeroCartaoSus: numeroCartaoSus ? numeroCartaoSus : "",
          possuiNumeroIdentidadeSocial: possuiNumeroIdentidadeSocial
            ? possuiNumeroIdentidadeSocial.trim()
            : "",
          numeroIdentidadeSocial: numeroIdentidadeSocial
            ? numeroIdentidadeSocial
            : "",
          ...resto,
        });
      })
      .catch((error) => {
        let path = `/crianca/visualizar-documentacao/${id}`;
        path += idAnexo ? `?idAnexo=${idAnexo}` : "";
        history.push(path);
        console.log("Erro no get de documentacao");
      });
  }, [id, isNascidoAposMar2011, history, idAnexo]);

  const schema = Yup.object().shape({
    registrada: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    matricula: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),

    livro: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S" && !isNascidoAposMar2011,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    folha: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S" && !isNascidoAposMar2011,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    termo: Yup.string()
      .nullable()
      .when("registrada", {
        is: (registrada) => registrada === "S" && !isNascidoAposMar2011,
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    certidao: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiIdentidade: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    numeroIdentidade: Yup.string()
      .nullable()
      .when("possuiIdentidade", {
        is: (possuiIdentidade) => possuiIdentidade === "S",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    orgaoExpedidor: Yup.string().nullable(),

    dataExpedicaoIdentidade: Yup.string()
      .nullable()
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .test("dataExpedicaoAfterToday", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      })
      .test("dataExpedicaoNotAfterBirthday", "", (value) => {
        if (!value || !dataNascimento) {
          return true;
        }

        const dataExpedicaoTimestamp = parse(value, "dd/MM/yyyy", new Date());
        return !isAfter(dataNascimento, dataExpedicaoTimestamp);
      }),

    identidade: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiCpf: Yup.string("Este campo é obrigatório!")
      .required("Este campo é obrigatório!")
      .when("possuiCtps", {
        is: (possuiCtps) => possuiCtps === "D",
        then: (schema) =>
          schema.test(
            "cpfRequired",
            "Cpf é obrigatório para CTPS digital!",
            (value) => {
              return value === "S";
            }
          ),
      }),
    cpf: Yup.string()
      .nullable()
      .when("possuiCpf", {
        is: (possuiCpf) => possuiCpf === "S",
        then: (schema) =>
          schema
            .required("Este campo é obrigatório!")
            .test("cpfValido", "", (value) => {
              if (!isValidCPF(value)) {
                return false;
              } else {
                return true;
              }
            }),
      })
      .test("unicidadeFamilia", "", (value) => {
        if (acolhedorValid) {
          return false;
        } else {
          return true;
        }
      }),

    anexoCpf: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiCtps: Yup.string("Este campo é obrigatório!")
      .nullable()
      .test("obrigatorio", "Este campo é obrigatório!", (value) => {
        const idade = intervalToDuration({
          start: new Date(dataCrianca.dataNascimento),
          end: new Date(),
        }).years;
        if (idade >= 16) {
          if (!!value) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }),
    numeroCtps: Yup.string()
      .nullable()
      .when("possuiCtps", {
        is: (possuiCtps) => possuiCtps === "F",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    serieCtps: Yup.string()
      .nullable()
      .when("possuiCtps", {
        is: (possuiCtps) => possuiCtps === "F",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    dataExpedicaoCtps: Yup.string()
      .nullable()
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return true;
        }
      })
      .test(
        "dataExpedicaoAfterToday",
        "A data informada não pode ser uma data futura!",
        (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }
      )
      .when("possuiCtps", {
        is: (possuiCtps) => possuiCtps === "F",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    ctps: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (value === null) {
          return true;
        } else {
          return value.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (value === null) {
          return true;
        } else {
          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (value.path.toString().toLowerCase().includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),
    possuiCartaoSus: Yup.string("Este campo é obrigatório!").required(
      "Este campo é obrigatório!"
    ),
    numeroCartaoSus: Yup.string()
      .nullable()
      .when("possuiCartaoSus", {
        is: (possuiCartaoSus) => possuiCartaoSus === "S",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
    possuiNumeroIdentidadeSocial: Yup.string(
      "Este campo é obrigatório!"
    ).required("Este campo é obrigatório!"),
    numeroIdentidadeSocial: Yup.string()
      .nullable()
      .when("possuiNumeroIdentidadeSocial", {
        is: (possuiNumeroIdentidadeSocial) =>
          possuiNumeroIdentidadeSocial === "S",
        then: (schema) => schema.required("Este campo é obrigatório!"),
      }),
  });

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const { dataExpedicaoIdentidade, cpf } = values;
        const currentDate = new Date();

        if (dataExpedicaoIdentidade) {
          const movementDate = parse(
            dataExpedicaoIdentidade,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataFutura(true);
            setDataMenor(false);
          } else {
            setDataFutura(false);
          }
        }

        if (dataNascimento && dataExpedicaoIdentidade) {
          const movementDate = parse(
            dataExpedicaoIdentidade,
            "dd/MM/yyyy",
            new Date()
          );

          if (
            isBefore(movementDate, dataNascimento) &&
            !isAfter(movementDate, currentDate)
          ) {
            setDataMenor(true);
          } else {
            setDataMenor(false);
          }
        }

        if (cpf) {
          if (isValidCPF(cpf)) {
            setInvalidCPF(true);
            setFieldError("cpf", "");
            if (
              cpf?.replace(/[.-]|[.-](?=.)/g, "").trim() !==
              initialValues?.cpf?.replace(/[.-]|[.-](?=.)/g, "").trim()
            ) {
              DocumentacaoService.getDocumentacaoValidar(id, cpf)
                .then(() => setAcolhedorValid(false))
                .catch((error) => {
                  setMessage(
                    error.response.data.message
                      ? error.response.data.message
                      : ""
                  );
                  setAcolhedorValid(true);
                });
            } else {
              setAcolhedorValid(false);
            }
          } else {
            setInvalidCPF(false);
            setFieldError("cpf", "");
          }
        }
      };

      validateDate();
    }, [values, values.dataMovimentacao, setFieldError]);

    return null;
  };

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        dataExpedicaoIdentidade,
        dataExpedicaoCtps,
        certidao,
        originalCertidao,
        identidade,
        originalIdentidade,
        anexoCpf,
        originalAnexoCpf,
        ctps,
        originalCtps,
        ...resto
      } = values;

      const valuesToSend = {
        dataExpedicaoIdentidade: dataExpedicaoIdentidade
          ? parse(
              dataExpedicaoIdentidade,
              "dd/MM/yyyy",
              new Date()
            ).toISOString()
          : "",
        dataExpedicaoCtps: dataExpedicaoCtps
          ? parse(dataExpedicaoCtps, "dd/MM/yyyy", new Date()).toISOString()
          : "",
        ...resto,
      };

      if (certidao) {
        valuesToSend["certidao"] = certidao;
      } else {
        valuesToSend["removerAnexoCertidao"] =
          certidaoEditada || ["SI", "N"].includes(values?.registrada);
      }
      if (identidade) {
        valuesToSend["identidade"] = identidade;
      } else {
        valuesToSend["removerAnexoIdentidade"] =
          identidadeEditada || ["SI", "N"].includes(values?.possuiIdentidade);
      }
      if (anexoCpf) {
        valuesToSend["anexoCpf"] = anexoCpf;
      } else {
        valuesToSend["removerAnexoCpf"] =
          anexoCpfEditado || ["SI", "N"].includes(values?.possuiCpf);
      }
      if (ctps) {
        valuesToSend["ctps"] = ctps;
      } else {
        valuesToSend["removerAnexoCtps"] =
          ctpsEditada || ["SI", "N"].includes(values?.possuiCtps);
      }

      DocumentacaoService.atualizarDocumentacao(id, valuesToSend)
        .then((res) => {
          history.push("/crianca/visualizar-documentacao/" + id);
          setAtualizarDocumentacao(true);
          setEditarDocCrianca(false);
          actions.setSubmitting(false);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.data) {
              if (error.response.data.message) {
                if (error.response.data.field === "cpf") {
                  console.log(error);
                  Swal.fire({
                    title: "Atenção!",
                    text: error.response.data.message
                      ? error.response.data.message
                      : "",
                    icon: "warning",
                    confirmButtonText: "Fechar",
                    confirmButtonColor: "#169499",
                  });
                } else {
                  const errors = JSON.parse(error.response.data.message);
                  for (let key in errors) {
                    const tempKey = key.toString().split("[0]")[0];
                    actions.setFieldError(tempKey, errors[tempKey]);
                  }
                }
              } else if (error.response.data.apierror) {
                if (error.response.data.apierror.subErrors) {
                  error.response.data.apierror.subErrors.forEach((erro) => {
                    actions.setFieldError(erro.field, erro.message);
                  });
                }
              }
            }
          } else {
            console.log(error);
          }
        });

      actions.setSubmitting(false);
    }, 200);
  };

  return roleKeycloack &&
    (roleKeycloack?.includes(vrCriancaFunc.documentacaoEditar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    dataCrianca ? (
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
        enableReinitialize
      >
        {(props) => (
          <Flex>
            {setEditarDocCrianca(hasFormChanged(initialValues, props.values))}
            <FocusErrorData />
            <Form style={{ width: "100%" }}>
              <CriancaRegistrada
                anexoEditado={certidaoEditada}
                setAnexoEditado={setCertidaoEditada}
                isNascidoAposMar2011={isNascidoAposMar2011}
                idAnexo={idAnexo}
                scrollToField={scrollToField}
              />
              <PossuiIdentidade
                props={props}
                anexoEditado={identidadeEditada}
                setAnexoEditado={setIdentidadeEditada}
                dataMenor={dataMenor}
                dataFutura={dataFutura}
                dataNascimento={dataNascimento}
                idAnexo={idAnexo}
                scrollToField={scrollToField}
              />
              <PossuiCPF
                anexoEditado={anexoCpfEditado}
                setAnexoEditado={setAnexoCpfEditado}
                invalidCPF={invalidCPF}
                acolhedorValid={acolhedorValid}
                message={message}
                idAnexo={idAnexo}
                scrollToField={scrollToField}
              />
              {intervalToDuration({
                start: new Date(dataCrianca.dataNascimento),
                end: new Date(),
              }).years >= 16 && (
                <PossuiCTPS
                  anexoEditado={ctpsEditada}
                  setAnexoEditado={setCtpsEditada}
                  idAnexo={idAnexo}
                  scrollToField={scrollToField}
                />
              )}
              <PossuiCartao />
              <PossuiNumero />

              <Flex mt="30px" justifyContent="flex-end">
                <CustomButton
                  type="submit"
                  translate="no"
                  isLoading={props.isSubmitting}
                  label="Salvar"
                />
              </Flex>
            </Form>
          </Flex>
        )}
      </Formik>
    ) : (
      <LoadingSpinner loading={true} />
    )
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
